/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbFormateurDiplomeGridDto } from './FcbFormateurDiplomeGridDto';
import {
    FcbFormateurDiplomeGridDtoFromJSON,
    FcbFormateurDiplomeGridDtoFromJSONTyped,
    FcbFormateurDiplomeGridDtoToJSON,
} from './FcbFormateurDiplomeGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbFormateurDiplomeGridDtoPaginatedResults
 */
export interface FcbFormateurDiplomeGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurDiplomeGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbFormateurDiplomeGridDto>}
     * @memberof FcbFormateurDiplomeGridDtoPaginatedResults
     */
    results?: Array<FcbFormateurDiplomeGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbFormateurDiplomeGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbFormateurDiplomeGridDtoPaginatedResults interface.
 */
export function instanceOfFcbFormateurDiplomeGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbFormateurDiplomeGridDtoPaginatedResultsFromJSON(json: any): FcbFormateurDiplomeGridDtoPaginatedResults {
    return FcbFormateurDiplomeGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbFormateurDiplomeGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbFormateurDiplomeGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbFormateurDiplomeGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbFormateurDiplomeGridDtoPaginatedResultsToJSON(value?: FcbFormateurDiplomeGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbFormateurDiplomeGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

